import { generatePath } from 'react-router'
import { AuthorLabel } from '~/components/Author'
import { routes } from '~/queries/routes'

import { colord } from 'colord'
import { Link } from '@remix-run/react'
import classNames from 'classnames'
import { ResponsiveImage } from '~/components/ResponsiveImage'
import { TypeArticle, TypeAuthor } from '~/types/contentful'
import { Asset } from 'contentful'

export interface RelatedPostProps {
  post: TypeArticle<'WITHOUT_UNRESOLVABLE_LINKS', string>
}

export const RelatedPost: React.FC<RelatedPostProps> = ({ post }) => {
  const { slug, title, color, illustration, author } = post.fields

  const isDark = colord(color as string).isDark() || false
  const illutrationImage = illustration as Asset<'WITHOUT_UNRESOLVABLE_LINKS', string>
  const authorEntry = author as TypeAuthor<'WITHOUT_UNRESOLVABLE_LINKS', string>

  return (
    <div
      className={classNames(
        'relative bg-neutral-5 text-neutral-100 flex rounded-3xl items-center mt-15 max-xl:mt-10 max-md:mt-7 max-md:py-2 max-md:px-3 max-md:rounded-xl p-3 pr-5 [&:not(:last-child)]:mb-15 max-xl:[&:not(:last-child)]:mb-10 max-md:[&:not(:last-child)]:mb-7',
        {
          'text-white': isDark,
        },
      )}
      style={{ backgroundColor: color }}
    >
      {illutrationImage && (
        <div className="w-44 h-auto mr-4 max-md:hidden">
          <ResponsiveImage asset={illutrationImage.fields} opts={{ width: 176 }} />
        </div>
      )}

      <div className="max-md:pb-4 pb-3">
        <div className="text-s flex items-center mb-1 px-0 py-1">
          Related article by {authorEntry && <AuthorLabel fields={authorEntry.fields} size="S" />}
        </div>
        {title && (
          <Link
            className="text-m block before:absolute before:content-none before:top-0 before:left-0 before:right-0 before:bottom-0"
            to={generatePath(routes.article, { slug })}
          >
            {title}
          </Link>
        )}
      </div>
    </div>
  )
}
